import { jsxs as v, jsx as d } from "react/jsx-runtime";
import { useState as O, useCallback as R } from "react";
import { useDom as g } from "../../../../context/Dom.js";
import { useContextPopupState as j, useElementDimensions as k, useAutoCloseOnClick as w } from "./hooks.js";
function I({
  position: s = "bottom",
  children: t,
  closeOnPopupClick: i = !0,
  hover: n = !1,
  closeDelay: r = 200,
  anchorWidth: u = "max-content",
  anchorHeight: e = "max-content",
  boundingElementRef: o,
  enablePopup: c = !0,
  onClosePopup: l
}) {
  const {
    openPopup: p,
    closePopup: a,
    isOpen: f,
    anchor: P,
    popup: m,
    anchorRef: h,
    setPopupDimensions: y,
    anchorProps: C,
    popupProps: D
  } = j({
    position: s,
    hover: n,
    closeDelay: r,
    boundingElementRef: o,
    enabled: c,
    onClosePopup: l
  }), x = {
    isOpen: f,
    openPopup: p,
    closePopup: a,
    anchorDimensions: P,
    popupDimensions: m
  }, { createPortal: b } = g();
  return /* @__PURE__ */ v("div", { style: { height: e }, children: [
    /* @__PURE__ */ d(
      "div",
      {
        ref: h,
        style: {
          position: "relative",
          width: u,
          height: e
        },
        children: t.anchor({ ...x, anchorProps: C })
      }
    ),
    f && b(
      /* @__PURE__ */ d(
        S,
        {
          ...x,
          popupProps: D,
          onLayout: y,
          top: m.top,
          left: m.left,
          closeOnPopupClick: i,
          children: t.popup
        }
      ),
      h.current
    )
  ] });
}
function S({
  children: s,
  top: t = 0,
  left: i = 0,
  onLayout: n,
  popupProps: r,
  closeOnPopupClick: u,
  ...e
}) {
  const [o, c] = O(!1), l = R(
    (a) => {
      o && n(a), c(!0);
    },
    [o, n]
  ), p = k(l);
  return w({
    isOpen: e.isOpen,
    closePopup: e.closePopup,
    closeOnPopupClick: u,
    popupRef: p
  }), /* @__PURE__ */ d(
    "div",
    {
      ref: p,
      style: {
        position: "absolute",
        width: "max-content",
        height: "max-content",
        top: `${t}px`,
        left: `${i}px`,
        opacity: o ? 1 : 0,
        zIndex: 100
      },
      ...r,
      children: s({ ...e })
    }
  );
}
export {
  I as default
};
